<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                v-model="tag.name"
                :label="$t('common:name')"
                :rules="[
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-select
                outlined
                clearable
                :items="metas"
                item-text="name"
                item-value="id"
                v-model="tag.metaInfo"
                :label="$t('settings/settings:tag.meta-info')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                  elevation="0"
                  flat
                  tile
                  class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:tag.tag') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:tag.tag') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import TagService from '@/modules/settings/services/tag-service';
import {ruleRequired} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: "SettingForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  props: {
    metas: Array
  },
  data() {
    return {
      tag: {},
      dialog: false,
      edit: false
    }
  },
  methods: {
    ruleRequired,
    updateForm() {

      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      TagService.saveTag(
          this.tag,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:tag.tag')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:tag.tag')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:tag.tag')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:tag.tag')}));
            }
          }
      )
    },
    initialization(item) {
      this.tag = {};
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.tag = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  }
}
</script>
